module.exports = __webpack_public_path__ + "static/media/qian.dfb79f02.svg";